import React from "react";
import { motion } from "framer-motion";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import BackButton from "./BackButton";
import "./FAQs.css";

const faqsData = [
  {
    
    category: "General Questions",
    questions: [
      { q: "What is AUBattle?", a: "AUBattle is an e-sports gaming platform where users can participate in competitive online tournaments, win prizes, and connect with other gamers." },
      { q: "How do I sign up for AUBattle?", a: "You can sign up by downloading the AUBattle app and creating an account using your email or social media login." },
      { q: "Is AUBattle free to use?", a: "Yes, AUBattle is free to download and use. However, entry fees may apply for certain tournaments." },
      { q: "What types of tournaments are available?", a: "AUBattle hosts a variety of free and paid tournaments across multiple popular games. Tournament details, including entry fees and prizes, are available in the app." }
    ]
  },
  {
    category: "Account & Eligibility",
    questions: [
      { q: "Who can participate in AUBattle tournaments?", a: "To participate, you must be at least 18 years old or the legal age in your jurisdiction." },
      { q: "Can I have multiple accounts?", a: "No, multiple accounts per user are not allowed. If found, all related accounts may be banned." },
      { q: "What if I forget my password?", a: "You can reset your password by clicking on 'Forgot Password' on the login screen and following the instructions." }
    ]
  },
  {
    category: "Tournaments & Gameplay",
    questions: [
      { q: "How do I join a tournament?", a: "You can browse upcoming tournaments in the app, select the one you want to join, and pay the entry fee (if required)." },
      { q: "What happens if a match is canceled?", a: "If a match is canceled due to server issues or other technical problems, your entry fee will be refunded to your wallet." },
      { q: "What if I miss my match start time?", a: "If you fail to enter the match before it starts, you will not be eligible for a refund." },
      { q: "What happens if I encounter a hacker or cheater?", a: "If you are eliminated due to a hacker or cheater, your entry fee will be refunded after verification." }
    ]
  },
  {
    category: "Payments & Prizes",
    questions: [
      { q: "How do I deposit money into my AUBattle wallet?", a: "You can add funds to your wallet through various payment methods available in the app, such as credit/debit cards, UPI, and digital wallets." },
      { q: "How are prizes distributed?", a: "Prizes are awarded based on the tournament details and are credited to the winner’s AUBattle account. Withdrawals can be requested through the app." },
      { q: "Are there any withdrawal limits?", a: "Yes, minimum and maximum withdrawal limits may apply depending on your payment method. Check the app for specific details." },
      { q: "Do I need to pay taxes on my winnings?", a: "Yes, users are responsible for any applicable taxes on their winnings as per their country’s tax laws." }
    ]
  },
  {
    category: "Fair Play & Security",
    questions: [
      { q: "What are the rules for fair play?", a: "Cheating, hacking, and teaming up unfairly are strictly prohibited. Violators will be disqualified and may face account bans." },
      { q: "How does AUBattle detect cheating?", a: "We use advanced anti-cheat systems and manual reviews to identify and eliminate fraudulent activities." },
      { q: "Can my account be banned?", a: "Yes, if you violate our terms by cheating, using hacks, or engaging in fraudulent activities, your account will be permanently banned." }
    ]
  },
  {
    category: "Support & Contact",
    questions: [
      { q: "How can I contact AUBattle support?", a: "You can reach our support team at [Your Support Email] for any inquiries or issues." },
      { q: "How do I report a problem?", a: "You can report issues through the app’s support section or email our support team with details of your problem." }
    ]
  }
];


const FAQs = () => {
  return (
    <div className="faqs-container dark-theme">
      <nav className="faqs-nav">
        <BackButton />
      </nav>

      <motion.h1 
        className="faqs-title"
        initial={{ opacity: 0, y: -50 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 0.8 }}
      >
        Frequently Asked Questions
      </motion.h1>

      <div className="faqs-content">
        {faqsData.map((section, index) => (
          <motion.div 
            key={index} 
            className="faq-section"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.1 * index, duration: 0.6 }}
          >
            <h2 className="section-title">
              <span className="section-icon">📌</span>
              {section.category}
            </h2>
            
            <div className="faq-items">
              {section.questions.map((faq, idx) => (
                <motion.div 
                  key={idx} 
                  className="faq-item"
                  whileHover={{ scale: 1.01 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <details>
                    <summary className="faq-question">
                      <span>{faq.q}</span>
                      <FiChevronDown className="chevron-down" />
                      <FiChevronUp className="chevron-up" />
                    </summary>
                    <div className="faq-answer">
                      <p>{faq.a}</p>
                    </div>
                  </details>
                </motion.div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default FAQs;